<template>
  <nav id="control_panel" :class="['w3-sidebar', 'w3-collapse', 'w3-animate-left', {'closeMenu': !isControlPanelOpen}]" v-if="isAuthenticated">
    <div class="w3-container w3-row">
      <div id="control_panel_content">
        <div class="w3-center logos">
          <router-link :to="{ path: '/home' }">
            <img src="@/assets/media/logo_sherpa2.png" alt="sherpa" class="w3-image sherpa">
            <img src="@/assets/media/logo1.png" alt="the mount data" class="w3-image mountdata">
          </router-link>
        </div>
        <div id="items_menu">
          <!--<vue-nice-scrollbar classes="menu-scrollbar" v-bind:speed=100 theme="light">-->
            <div class="scroll-me">
              <div v-for="item in currentMenu" :key="item.id" :class="[item.id]">
                <!-- internal link -->
                <router-link v-if="item.contextPath"
                  :to="{ path: item.parentContextPath + item.contextPath }"
                  v-tooltip.right="{content: item.name, delay: { show: 400, hide: 100 } , container: '#items_menu .' + item.id}"
                >
                  <div class="item-menu">
                    <i :class="['sherpa-icon', 'icon-'+item.id]"></i><span> {{item.name}} </span>
                  </div>
                </router-link>

                <!-- external link -->
                <a v-else-if="item.externalUrl"
                  :href="item.externalUrl"
                  target="_blank"
                  v-tooltip.right="{content: item.name, delay: { show: 400, hide: 100 }, container: '#items_menu'}"
                >
                  <div class="item-menu">
                    <i :class="['sherpa-icon', 'icon-'+item.id]"></i><span> {{item.name}} </span>
                  </div>
                </a>
              </div>
            </div>
          <!--</vue-nice-scrollbar>-->
        </div>
      </div>
      <div id="control_panel_control">
        <i id="toggle_control_panel" class="fa fa-angle-left" v-on:click="toggleControlPanel()"></i>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapGetters } from 'vuex'
import * as authTypes from '@/store/actions/auth'
import * as appTypes from '@/store/actions/app'
import * as controlPanelTypes from '@/store/actions/controlPanel'
import vueNiceScrollbar from 'vue-nice-scrollbar'

export default {
  name: 'app-menu',
  components: {
    vueNiceScrollbar
  },
  data () {
    return {
      currentMenu: [],
      showTooltip: false
    }
  },
  methods: {
    toggleControlPanel (action) {
      this.$store.dispatch(`${controlPanelTypes.CONTROL_PANEL_NAMESPACE}/${controlPanelTypes.CONTROL_PANEL_TOGGLE}`)
    }
  },
  computed: {
    ...mapGetters(`${authTypes.AUTH_NAMESPACE}`, [`${authTypes.AUTH_AUTHENTICATED}`]),
    ...mapGetters(`${controlPanelTypes.CONTROL_PANEL_NAMESPACE}`, [`${controlPanelTypes.CONTROL_PANEL_IS_OPEN}`]),
    menu () {
      return this.$store.getters[`${appTypes.APP_NAMESPACE}/${appTypes.APP_CURRENT_MENU}`]
    }
  },
  watch: {
    menu: function (menu) {
      this.currentMenu = menu
    }
  }
}
</script>

<!-- scroll bar -->
<style>
/*The Wrapper*/
.menu-scrollbar {
  max-height: 770px;
}
/*The Content*/
/* .scroll-me{
} */
</style>

<style lang="scss">
.scroll-me {
  > div {
    position: relative;
  }
  .home {
    display: none;
  }
}
#control_panel {
  width: 300px;
  height: 100%;
  margin: 0;
  padding: 0;
  z-index: 1;
  overflow: initial;
  transition: width 0.5s;
  background-color: #5dbecb;

  >.w3-container {
    width: auto;
    height: 100%;
    margin: 0;
    padding: 0;

    #control_panel_content {
      position: absolute;
      width: 100%;
      height: 100%;
      margin: 0;
      padding: 0;
      transition: width 0.5s;

      .logos {
        padding: 0 10px;

        .mountdata {
          transition: all 0.3s;
          width: 120px;
          margin-top: 20px
        }

        .sherpa {
          transition: all 0.3s;
          width: 42px;
          margin-top: 20px
        }

        .mountdata {
          display: none;
        }
      }

      #items_menu {
        margin-top: 23px;
        height: 100%;

        a {
          text-decoration: none;
          color: white;

          .item-menu {
            width: 100%;
            margin: 0;
            transition: all 0.3s;
            text-align: center;
            padding: 15px 10px 10px;

            i {
              color: white;
              font-size: 2em;
              vertical-align: middle;
            }

            span {
              margin-left: 30px;
              font-family: Barlow;
              font-size: 20px;
              font-weight: 400;
              font-style: normal;
              font-stretch: normal;
              line-height: normal;
              letter-spacing: normal;
              color: #ffffff;
              text-transform: capitalize;
              vertical-align: text-bottom;
              transition: all 0.3s;
              position: absolute;
              margin-top: 11px;
            }
          }
        }

        a.link-active div,
        a:hover div {
          background-color: #5FADBC;
        }
      }

      .menu_tancat {
        display: none;
        position: relative;
        width: 100px;
        height: 100px;

        a {
          position: absolute;
          width: 100%;
          height: 100%;
          padding: 30px;
          color: white;
          transition: all 0.3s;

          i {
            font-size: 2.7em;
          }
        }

        a.link-active,
        a:hover {
          background-color: #5FADBC;
        }
      }
    }

    #control_panel_control {
      display: none;
      position: absolute;
      top: 50%;
      right: -5px;
      transition: all 0.5s;

      i {
        position: absolute;
        font-size: 2em;
        left: 10px;
        bottom: 48%;
        cursor: pointer;
        color: #FFBD42;
      }
    }
  }

  &.closeMenu{
    width: 100px;

    #control_panel_content {
      .logos {
        .mountdata {
          opacity: 0;
        }
        .sherpa {
          margin-top: 16px;
        }
      }
      #items_menu {
        a {
          .item-menu {
            span {
              display: none;
              opacity: 0;
              max-width: 0;
            }
          }
        }
      }
    }

    #control_panel_control {
      transform: rotateY(180deg);
      right: -42px;
    }
  }
}

#control_panel.active {
  width: 100px;
  transition: width 0.5s;
}

#control_panel .tooltip {
  display: none !important;
  transform: initial !important;
  top: 22px !important;
  left: 100px !important;
  white-space: nowrap;
}
#control_panel.closeMenu .tooltip {
  display: block !important;
}
</style>



// WEBPACK FOOTER //
// src/components/appMenu/index.vue